import { render, staticRenderFns } from "./CbrAvaliabilityList.vue?vue&type=template&id=3744ad20&lang=pug"
import script from "./CbrAvaliabilityList.vue?vue&type=script&lang=js"
export * from "./CbrAvaliabilityList.vue?vue&type=script&lang=js"
import style0 from "./CbrAvaliabilityList.vue?vue&type=style&index=0&id=3744ad20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports